__turbopack_context__.v({
  "clouds": "CloudDecorations-module-scss-module__pF2tmW__clouds",
});
